import { Outlet } from 'react-router'
import { MarqueeHeader } from '@/features/marquee/components/marquee-header'

function MarqueeLayout() {
	return (
		// The document body scrolls; the app header stays sticky at the top.
		// Individual pages keep chrome (tabs, footer bars) pinned as needed.
		<div className='flex min-h-dvh flex-col'>
			<MarqueeHeader className='sticky top-0 z-(--z-sticky-header) shrink-0' />
			<div className='flex flex-1 flex-col'>
				<Outlet />
			</div>
		</div>
	)
}

export { MarqueeLayout }
